
import React from 'react';
import {Params} from './../params.jsx'
import { Link } from "react-router-dom";


const SecondHead = (props) => {

    return (
        


	<div className="second-head h-auto">
      <div className="row">

        <div className="col-md-4 px-auto pt-3">
          
            <p className="text-center text-md-end text-light fs-6">
              <a href={`tel:${Params().userPhone}`} className="text-light">
                {Params().userPhone}
              </a>
            </p>
        </div>
        <div className="col-md-4 px-auto pt-3">

            <p className="text-center text-light fs-6">
              <a href={`mailto:${Params().userEmail}`} className="text-light">
                {Params().userEmail}
              </a>
            </p>
        </div>
        <div className="col-md-4 px-auto pt-3">
        {props.link ? 
            <p id="head_about" className="text-center text-md-start text-light fs-6">
              <Link to="/rooms" className="text-light">
                {Params(props.lang).rooms}
              </Link>
            </p>
        :
            <p id="head_main" className="text-center text-md-start text-light fs-6">
              <Link to="/" className="text-light">
                {Params(props.lang).main}
              </Link>
            </p>
   		 }

        </div>




        </div>

    </div>
    );
};
export default SecondHead;